import classNames from 'classnames';
import { Option } from 'model/Form';
import React from 'react';
import { useI18n } from 'next-localization';

type SelectedFiltersProps = {
  appliedFilterOptions: Option[]; // Array of selected filter options
  onDeleteOption: (option: Option) => void; // Callback when a filter option is deleted
  onClearFilters: () => void; // Callback when clearing all filters
  className?: string;
};

const SelectedFilters: React.FC<SelectedFiltersProps> = ({
  appliedFilterOptions,
  onDeleteOption,
  onClearFilters,
  className,
}) => {
  const { t } = useI18n();
  return (
    <div
      className={classNames(
        'd-flex align-items-center flex-wrap filter-options-wrapper gap-2',
        className
      )}
    >
      {/* Render each approved filter */}
      {appliedFilterOptions.map((option) => (
        <button
          key={`${option.value || option.text}-fab`}
          className="filter-option-selected d-flex btn-naked"
          aria-label={`Remove filter option: ${option.displayName || option.text}`}
          onClick={() => onDeleteOption(option)}
        >
          <span className="form-label">{option.displayName || option.text}</span>
          <em className="d-flex bi-x-lg ms-2" aria-hidden="true" />
        </button>
      ))}

      {/* Clear all filters button */}
      <button
        className="inline-link inline-link--small text-decoration-underline btn-naked"
        aria-label="Clear all filters"
        onClick={onClearFilters}
      >
        {t('clearAll')}
      </button>
    </div>
  );
};

export default SelectedFilters;
